import { Box, Typography } from '@mui/joy';
import { Signpost } from '@phosphor-icons/react';

/**
 * «С чего начать» — карточка над списком дисциплин учебного плана.
 * Текст согласован владельцем 05.09.2026. Всегда раскрыта.
 *
 * freeOrder=true: полный доступ, дисциплины открыты в любом порядке
 * (бэкенд отдаёт `free_order` в ответе списка роадмапов).
 * freeOrder=false: триал / qbank_only — открыты три дисциплины, остальные в годовом.
 */

const POINTS_FREE_ORDER = [
    {
        title: 'Порядок свободный.',
        text: 'Дисциплины не зависят друг от друга. Начинайте с той, что слабее всего или ближе к экзамену. Если сомневаетесь, идите сверху вниз, порядок совпадает с First Aid.',
    },
    {
        title: 'Внутри дисциплины дни идут по очереди.',
        text: 'Следующий день открывает тест-гейт в конце блока.',
    },
    {
        title: 'Можно вести несколько дисциплин параллельно.',
        text: 'Прогресс хранится по каждой отдельно.',
    },
];

const POINTS_LIMITED = [
    {
        title: 'Открыты Биохимия, Иммунология и Кардиология.',
        text: 'Остальные дисциплины в годовом тарифе.',
    },
    POINTS_FREE_ORDER[1],
    POINTS_FREE_ORDER[2],
];

const accent = (theme) => theme.palette.mode === 'dark' ? '#DA7756' : '#B84C31';

export default function StartHere({ freeOrder }) {
    const points = freeOrder ? POINTS_FREE_ORDER : POINTS_LIMITED;
    return (
        <Box sx={{
            mb: 3, p: { xs: 2, sm: 2.5 }, borderRadius: '16px', border: '1px solid',
            borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#FFFFFF',
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
                <Box sx={{
                    width: 32, height: 32, borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(218,119,86,0.15)' : 'rgba(184,76,49,0.1)', color: accent,
                }}>
                    <Signpost size={18} weight="duotone" />
                </Box>
                <Typography sx={{ fontSize: '1rem', fontWeight: 650, letterSpacing: '-0.01em' }}>С чего начать</Typography>
            </Box>
            <Box component="ol" sx={{ m: 0, pl: 0, listStyle: 'none', display: 'grid', gap: 1 }}>
                {points.map((p, i) => (
                    <Box component="li" key={p.title} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                        <Box sx={{
                            width: 24, height: 24, borderRadius: '8px', flexShrink: 0, mt: '1px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '0.78rem', fontWeight: 700, color: accent,
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.045)',
                        }}>{i + 1}</Box>
                        <Typography sx={{ fontSize: '0.9rem', lineHeight: 1.65, letterSpacing: '-0.005em', color: 'text.primary' }}>
                            <Box component="span" sx={{ fontWeight: 650 }}>{p.title}</Box>{' '}{p.text}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
